<section class="input-template-container">
  <div class="action-buttons-container">
    <!-- Warning Message -->
    <p class="warning-message">
      <!-- Shortcut Link Warning -->
      <span class="message" *ngIf="isShortcutView">
        {{ "templates.modified_values_warning" | translate }}
      </span>

      <!-- L2 Data Changed Warning -->
      <span class="message" *ngIf="isLevel2DataChanged">
        {{ "templates.level2_data_changed_message" | translate }}
      </span>
    </p>

    <!-- Save -->
    <button type="button" mat-raised-button color="primary" (click)="onClickSave()" [disabled]="isSaveButtonDisabled()"
      *ngIf="!isShortcutView">
      <mat-icon>save</mat-icon>
      {{
      (model.activeLevel === bridgeConstants.levels.l0
      ? "common.buttons.save_as_draft"
      : "common.buttons.save"
      ) | translate
      }}
    </button>

    <!-- Back -->
    <button type="button" mat-stroked-button color="primary" (click)="onClickBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ "common.buttons.back" | translate }}
    </button>
  </div>

  <!-- Formly Form -->
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model" [options]="options"></formly-form>
  </form>

  <!-- TEMP: Debug Panel -->
  <cube-debug-panel [form]="form.value" [levelNamesList]="levelsList" [model]="model" [options]="options"
    *ngIf="devMode.showDebugPanel"></cube-debug-panel>
</section>
